import { render, staticRenderFns } from "./collect-pop.vue?vue&type=template&id=6772c0ea&"
import script from "./collect-pop.vue?vue&type=script&lang=js&"
export * from "./collect-pop.vue?vue&type=script&lang=js&"
import style0 from "./collect-pop.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports